export default "__VITE_ASSET__BldKlP_V__"